(() => {
  const cleanLink = (link) => {
    try {
      const url = new URL(link.href, window.location.href);
      if ((url.searchParams.get('ref') || '').toLowerCase() === 'pelle') {
        url.searchParams.delete('ref');
        link.href = url.href;
      }
    } catch (_) {}
  };

  const cleanAffiliateRefs = (root = document) => {
    if (root.matches?.('a[href*="ref=pelle" i]')) cleanLink(root);
    root.querySelectorAll?.('a[href*="ref=pelle" i]').forEach(cleanLink);
  };

  try {
    const current = new URL(window.location.href);
    if ((current.searchParams.get('ref') || '').toLowerCase() === 'pelle') {
      current.searchParams.delete('ref');
      window.history.replaceState(null, '', current.pathname + current.search + current.hash);
    }
  } catch (_) {}

  cleanAffiliateRefs();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) cleanAffiliateRefs(node);
      });

      if (mutation.type === 'attributes') cleanAffiliateRefs(mutation.target);
    }
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['href']
  });
})();